import PageCard from 'features/shared/components/card/PageCard';
import InfoItemInline from 'features/shared/components/infoItem/InfoItemInline';
import { formatPrice } from 'features/shared/helpers/Formatters';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PriceDTO from '../dtos/PriceDTO';

type Props = {
  prices: PriceDTO[];
  className?: string;
}

const ContractPricesCard = ({ prices, className }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // helpers
  const getFormattedValue = (price: PriceDTO) => { 
    let formattedPrice = formatPrice(price.amount!, price.currency!, 2);

    if (price.priceType?.unit) {
      return `${formattedPrice}/${price.priceType.unit}`
    }

    return formattedPrice;
  }

  // sub-renders
  const renderPrices = () => { 
    return prices.map((price, index) =>
      <InfoItemInline 
        title={price.priceType?.label!}
        value={getFormattedValue(price)}
        key={index}
      />
    );
  }

  // render
  return (
    <PageCard title={tLabels("contractPricesCard.prices")} cardClassName={className}>
      {renderPrices()}
    </PageCard>
  )
}

export default ContractPricesCard;